<template>
    <div class="mt-3">
        <div class="card">
            <div class="card-header">
                Home
            </div>
            <div class="card-body">
                <h5 class="card-title">Web Service Antrean</h5>
                <p class="card-text">Web Service Antrean - BPJS.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //
        }
    }
}
</script>
